import { QueryParams } from "../common/types/apiTypes";
import { Options } from "../common/types/requestOptions";
import { api } from "./api";

export const query = <
  TFilters extends QueryParams, // filter type
  TResponse, // return type
>(
  endpoint: string,
  filters: TFilters,
  options: Options = {},
): Promise<TResponse> => {
  return api
    .get<Promise<TResponse>>(endpoint, {
      requestId: options.requestId,
      queryParams: {
        ...filters,
      },
      auth: true,
    })
    .then((res) => res.data);
};
